import { render, staticRenderFns } from "./Redirecting.vue?vue&type=template&id=55de0e9e&"
import script from "./Redirecting.vue?vue&type=script&lang=js&"
export * from "./Redirecting.vue?vue&type=script&lang=js&"
import style0 from "./Redirecting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports